/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BadBrokerOwnedElectronicStorageSystemModel } from './badBrokerOwnedElectronicStorageSystemModel';
import { BadNotBrokerOwnedElectronicStorageSystemModel } from './badNotBrokerOwnedElectronicStorageSystemModel';
import { BadOffSiteStorageLocationModel } from './badOffSiteStorageLocationModel';
import { BadPropertyManagementAccountingSystemModel } from './badPropertyManagementAccountingSystemModel';
import { BadTransactionManagementSystemModel } from './badTransactionManagementSystemModel';
import { BadTrustAccountModel } from './badTrustAccountModel';


/**
 * Broker Audit Data model
 */
export class BrokerAuditDataModel { 
    LastUpdated?: Date;
    BusinessBrokerage?: boolean;
    CommercialPropMgmt?: boolean;
    CommercialSales?: boolean;
    FarmAndRanch?: boolean;
    HomeOffice?: boolean;
    MaintainsErrorsAndOmissionsInsurance?: boolean;
    MaintainsGeneralTrustAccounts?: boolean;
    MaintainsPropertyManagementTrustAccounts?: boolean;
    NewHomeSubdivision?: boolean;
    NumAssociateBrokersDelegatedBrokerDuties?: number;
    NumCommercialBuildings?: number;
    NumCommercialLeaseTransactions?: number;
    NumLicensedEmployees?: number;
    NumLicenseesCommercialPropertyManagement?: number;
    NumLicenseesResidentialPropertyManagement?: number;
    NumMultiFamilyDoors?: number;
    NumMultiFamilyUnits?: number;
    NumOtherCommercial?: number;
    NumOtherResidential?: number;
    NumRealEstateTeams?: number;
    NumResidentialLeaseTransactions?: number;
    NumSalesTransactions?: number;
    NumShoppingCenters?: number;
    NumSingleFamilyHomes?: number;
    NumUnlicensedFullTimeEmployees?: number;
    NumUnlicensedPartTimeEmployees?: number;
    Other?: boolean;
    OtherCommercialText?: string;
    OtherResidentialText?: string;
    OtherSubdivision?: boolean;
    OtherText?: string;
    ReferralBrokerage?: boolean;
    ResidentialPropMgmt?: boolean;
    ResidentialRealEstate?: boolean;
    Timeshare?: boolean;
    UtilizesNotOwnedElectronicStorageSystems?: boolean;
    UtilizesOffSiteStorageLocations?: boolean;
    UtilizesOwnedElectronicStorageSystems?: boolean;
    UtilizesPropertyManagementAccountingSystems?: boolean;
    UtilizesTransactionManagementSystems?: boolean;
    GeneralTrustAccounts?: Array<BadTrustAccountModel> = [];
    PropertyManagementTrustAccounts?: Array<BadTrustAccountModel> = [];
    OffSiteStorageLocations?: Array<BadOffSiteStorageLocationModel> = [];
    TransactionManagementSystems?: Array<BadTransactionManagementSystemModel> = [];
    PropertyManagementAccountingSystems?: Array<BadPropertyManagementAccountingSystemModel> = [];
    BrokerOwnedElectronicStorageSystems?: Array<BadBrokerOwnedElectronicStorageSystemModel> = [];
    NotBrokerOwnedElectronicStorageSystems?: Array<BadNotBrokerOwnedElectronicStorageSystemModel> = [];
}



// WEBPACK FOOTER //
// ./src/app/model/brokerAuditDataModel.ts